import axios from 'axios'
import { useRouter } from 'vue-router'
import _ from 'lodash'
import { useAuthStore } from 'src/stores'
import checkStatus from 'src/common/helpers/functions/checkStatus'

/* ----------------------------- Business Client ---------------------------- */
const businessClient = () => {
  const authStore = useAuthStore()
  const router = useRouter()

  // const generalStore = useGeneralStore()
  const client = axios.create({
    baseURL: `${authStore.loginData.business_url}/api/v1`,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })

  /* -------------------------------------------------------------------------- */
  /*                                   Request                                  */
  /* -------------------------------------------------------------------------- */
  client.interceptors.request.use((request) => {
    if (process.env.CLIENT && authStore.token) {
      request.headers.Authorization = `Bearer ${authStore.token}`
    }
    return request
  })

  /* -------------------------------------------------------------------------- */
  /*                                  Response                                  */
  /* -------------------------------------------------------------------------- */
  client.interceptors.response.use(
    (response) => {
      // let portalVersion = response.data.portal_version
      // if (!portalVersion) return response
      // else portalVersion = portalVersion.split('.').join('')

      // const newVersion = Number(portalVersion)
      // const lastVersion = generalStore.portalVersion

      // console.log('business', { newVersion, lastVersion })

      // if (!lastVersion || lastVersion < newVersion) {
      //   generalStore.portalVersion = newVersion
      //   process.env.CLIENT && location.reload()
      // }

      if ('data' in response.data) {
        response.meta = _.omit(response.data, ['data'])
        response.data = response.data.data
      } else response.meta = {}

      return response
    },
    (error) => {
      checkStatus(error?.response?.status, router)
      throw error
    },
  )

  return client
}

// /* -------------------------------------------------------------------------- */
// /*                                   Request                                  */
// /* -------------------------------------------------------------------------- */
// if (authStore.loginData.business_url)
//   businessClient().interceptors.request.use((request) => {
//     if (process.env.CLIENT && authStore.token)
//       request.headers.Authorization = `Bearer ${authStore.token}`
//     return request
//   })

// /* -------------------------------------------------------------------------- */
// /*                                  Response                                  */
// /* -------------------------------------------------------------------------- */
// if (authStore.loginData.business_url)
//   businessClient().interceptors.response.use((response) => {
//     let portalVersion = response.data.portal_version
//     if (!portalVersion) return response
//     else portalVersion = portalVersion.split('.').join('')

//     const newVersion = Number(portalVersion)
//     const lastVersion = generalStore.portalVersion

//     if (!lastVersion) {
//       generalStore.portalVersion = newVersion
//     } else if (lastVersion < newVersion) {
//       process.env.CLIENT && location.reload()
//     }

//     if ('data' in response.data) {
//       response.meta = _.omit(response.data, ['data'])
//       response.data = response.data.data
//     } else response.meta = {}

//     return response
//   })

export default businessClient
